export default {
  appName: 'Scan My Audio',
  general: {
    email: 'Email',
    name: 'Name',
    phone: 'Phone',
    role: 'Role',
    loading: 'Loading...',
    notFound: '404: Page not found!',
  },
  publicNav: {
    login: 'Login',
    register: 'Register',
  },
  authedNav: {
    jobs: 'Jobs',
    createJob: 'Upload',
    keywords: 'Keywords',
    myAccount: 'My Account',
    signOut: 'Sign Out',
  },
  dashboard: {
    title: 'Dashboard!',
    welcome: 'Welcome {name}',
  },
  forgottenPassword: {
    title: 'Forgotten Password',
    emailLabel: 'Email Address',
    emailInvalid: 'Please enter a valid email address',
    btnText: 'Request Reset',
    btnLoadingText: 'Sending you an email...',
    rememberedPrompt: 'Remembered your password?',
    login: 'Login',
    requestSent: 'Request has been sent! Please check your emails!',
  },
  login: {
    title: 'Login',
    emailLabel: 'Email Address',
    emailInvalid: 'Please enter a valid email address',
    passwordLabel: 'Password',
    passwordInvalid: 'Please enter your password',
    btnText: 'Login',
    btnLoadingText: 'Logging you in...',
    forgottenPassword: 'Forgotten your password?',
    requestReset: 'Request a reset',
    needAccount: 'Need an account?',
    clickHere: 'Click here',
    getStarted: 'to get started',
    submitError: 'Invalid email address or password.',
    loginWelcomeMessage: 'Welcome back {name}!',
  },
  myAccount: {
    title: 'My Account',
    myDetails: 'My Details',
    yourTeam: 'Your Team',
    accountSettings: 'Account Settings',
  },
  inviteUser: {
    firstNameLabel: 'First Name',
    firstNameInvalid: 'Please enter their first name',
    lastNameLabel: 'Last Name',
    lastNameInvalid: 'Please enter their last name',
    phoneNumberLabel: 'Phone Number',
    phoneNumberInvalid: 'Please enter a valid phone number',
    emailLabel: 'Email Address',
    emailInvalid: 'Please enter a valid email address',
    roleLabel: 'Role',
    roleAdmin: 'Admin',
    roleMember: 'Member',
    roleGuest: 'Guest',
    btnText: 'Invite User',
    btnLoadingText: 'Inviting...',
    inviteSent: 'Invite sent to {name}',
    inviteError: 'Unable to invite {name}! Please check the details you have entered and try again',
  },
  teamMembers: {
    removeUser: 'Remove User',
    errorFetchingTeamMembers: 'Something went wrong fetching your account members, sorry!',
    successfullyRemovedUser: '{name} has been removed!',
    errorRemovingUser: 'Something went wrong removing {name}. Please try again later, sorry!',
    removeUserModalTitle: 'Are you sure?',
    removeUserModalText: 'Once removed {name} will no longer be able to access {appName}',
  },
  changePassword: {
    currentPasswordLabel: 'Current Password',
    currentPasswordInvalid: 'Please enter your current password',
    newPasswordLabel: 'New Password',
    newPasswordInvalid: 'Please enter your new password',
    confirmNewPasswordLabel: 'Confirm New Password',
    confirmNewPasswordInvalid: 'Confirm new password must match your new password',
    btnText: 'Change Password',
    btnLoadingText: 'Changing...',
    passwordChanged: 'Successfully changed your password!',
    errorChangingPassword: 'Something went wrong changing your password! Please try again.',
  },
  register: {
    title: 'Register',
    firstNameLabel: 'First Name',
    firstNameInvalid: 'Please enter your first name',
    lastNameLabel: 'Last Name',
    lastNameInvalid: 'Please enter your last name',
    phoneNumberLabel: 'Phone Number',
    phoneNumberInvalid: 'Please enter a valid phone number',
    emailLabel: 'Email Address',
    emailInvalid: 'Please enter a valid email address',
    passwordLabel: 'Password',
    passwordInvalid: 'Please enter your password',
    confirmPasswordLabel: 'Confirm Password',
    confirmPasswordInvalid: 'Confirm password must match your password',
    btnText: 'Register',
    btnLoadingText: 'Creating your account...',
    alreadyAccount: 'Already got an account?',
    clickHere: 'Click here',
    toLogin: 'to login',
    welcomeMessage: 'greetings {name}!',
    errorMessage: 'Something went wrong creating your account! Please try again later',
  },
  registerFromInvite: {
    title: 'Welcome to {appName}!',
  },
  registerFromInviteForm: {
    info: 'Complete your registration for {appName} by filling out the below details.',
    passwordLabel: 'Password',
    passwordInvalid: 'Please enter your password',
    confirmPasswordLabel: 'Confirm Password',
    confirmPasswordInvalid: 'Confirm password must match your password',
    btnText: 'Register',
    btnLoadingText: 'Creating your account...',
    errorMessage: 'Your invite code is either invalid or expired. Please request another invite.',
    registerMessage: 'Welcome to {appName} {name}',
  },
  resetPassword: {
    title: 'Reset Password',
    passwordLabel: 'Password',
    passwordInvalid: 'Please enter your password',
    confirmPasswordLabel: 'Confirm Password',
    confirmPasswordInvalid: 'Confirm password must match your password',
    btnText: 'Reset Password',
    btnLoadingText: 'Resetting your password...',
    passwordReset: 'Your password has been reset!',
    resetLinkExpired: 'Reset link has expired. Please',
    clickHere: 'Click Here',
    requestAnother: 'to request another.',
  },
  createJob: {
    title: 'Search a file',
    fileUploadLabel: 'Upload a file',
    fileUploadInvalid: 'Please select a file to search',
    additionalKeywordsLabel: 'Additional keywords',
    additionalKeywordsDescription: 'Please enter words or phrases separated by a comma',
    jobNameLabel: 'Job name',
    jobNameInvalid: 'Please enter a name for this job',
    inputLanguageLabel: 'Input Language',
    inputLanguageInvalid: 'Please select your files input language',
    desiredLanguageLabel: 'Desired Language',
    desiredLanguageInvalid: 'Please select your desired language',
    uploadButton: 'Upload file',
    uploadButtonLoading: 'Uploading file...',
    uploadBegunInfo: 'Your upload has begun! Please don\'t leave the page until it has completed',
    jobCreated: 'Job: {name} is now processing!',
    errorCreatingJob: 'Error creating job. Please try again in a moment',
  },
  myJobsTable: {
    title: 'My Jobs',
    jobNameFilterLabel: 'Job Name',
    jobNameFilterPlaceholder: 'Search for name...',
    jobStatusFilterLabel: 'Status',
    jobStatusAllLabel: 'All',
    jobStatusProcessingLabel: 'Processing',
    jobStatusCompletedLabel: 'Completed',
    jobStatusFailedLabel: 'Failed',
    jobStatusCancelledLabel: 'Cancelled',
    jobFromFilterLabel: 'From',
    jobFromFilterPlaceholder: 'No date selected',
    jobToFilterLabel: 'To',
    jobToFilterPlaceholder: 'No date selected',
    errorFetchingJobs: 'Error fetching your jobs! Please check your connection and try again',
    tableJobName: 'Job Name',
    tableJobInfo: 'Jobs',
    tableInputLanguage: 'Input Language',
    tableDesiredLanguage: 'Desired Language',
    tableStatus: 'Status',
    tableActions: 'Actions',
    tableLoading: 'Loading...',
    tableEmpty: 'No jobs found.',
  },
  keywordsTable: {
    title: 'My Keywords',
    keywordFilterLabel: 'Keyword',
    keywordFilterPlaceholder: 'Search...',
    tableLoading: 'Loading...',
    tableEmpty: 'No keywords found.',
    tableKeyword: 'Keyword',
    tableLanguage: 'Language',
    tableActions: 'Actions',
    createKeyword: 'Add Keywords',
    keywordRemoveTitle: 'Are you sure?',
    keywordRemoveText: 'Once removed keyword: "{keyword}" will be gone forever.',
    keywordRemoveSuccess: 'Keyword: {keyword} has been removed!',
    keywordRemoveError: 'Error removing keyword. Please refresh the page and try again',
  },
  createKeywordsModal: {
    title: 'Add Keywords',
    uploadingCsv: 'Processing your CSV...',
    csvProcessed: 'Your CSV has been processed',
    csvError: 'There was an error uploading your CSV file. Please check it matches the template',
    keywordsCreateSuccess: 'Your keywords have been added!',
    keywordsCreateError: 'Unable to add your keywords. Please refresh the page and try again',
    languageLabel: 'Language',
    keywordsLabel: 'Keywords',
    downloadCSV: 'Download CSV Template',
    uploadCSV: 'Upload CSV',
    createKeywords: 'Add Keywords',
    createKeywordsLoading: 'Adding Keywords...',
  },
  viewJob: {
    loading: 'Loading...',
  },
  jobDetails: {
    inputLanguageLabel: 'Input Language',
    desiredLanguageLabel: 'Desired Language',
    statusLabel: 'Status',
    secondsUsedLabel: 'Seconds Used',
  },
  keywordAnalysisTable: {
    title: 'Keyword Analysis',
    tableEmpty: 'No keywords found',
    tableKeyword: 'Keyword',
    tableActions: 'Actions',
  },
  jobAudioFile: {
    title: 'Audio File',
  },
};
